import { authHeader, handleResponse } from "../helpers";


export const siteMasterService = {
  getAdminSiteDetails,
  getSiteStatus,
  getStateDDL,
  getCityDDL,
  getContractorDetails,
  getArchitectDetailsByMobile,
  getCarpenterDetailsByMobile,
  createSite,
};

function getAdminSiteDetails(data) {
  return fetch(`${process.env.REACT_APP_API_URL}CategoryMaster/GetAdminSiteDetails`, {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  }).then(handleResponse);
}

function getSiteStatus() {
  return fetch(`${process.env.REACT_APP_API_URL}UserMaster/GetSiteStatus`, {
    method: "GET",
    headers: authHeader(),
  }).then(handleResponse);
}

function getStateDDL(countryId = 1) {
  return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/GetStateDLL/${countryId}`, {
    method: "GET",
    headers: authHeader(),
  }).then(handleResponse);
}

function getCityDDL(stateId = 1) {
  return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/GetCityDLL/${stateId}`, {
    method: "GET",
    headers: authHeader(),
  }).then(handleResponse);
}

function getContractorDetails(data) {
  return fetch(`${process.env.REACT_APP_API_URL}CategoryMaster/GetContractorDetails`, {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  }).then(handleResponse);
}

function getArchitectDetailsByMobile(data) {
  return fetch(`${process.env.REACT_APP_API_URL}CategoryMaster/GetArchitectDetailsByMobile`, {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  }).then(handleResponse);
}

function getCarpenterDetailsByMobile(data) {
  return fetch(`${process.env.REACT_APP_API_URL}CategoryMaster/GetCarpenterDetailsByMobile`, {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  }).then(handleResponse);
}

function createSite(data) {
  return fetch(`${process.env.REACT_APP_API_URL}CategoryMaster/CreateSite`, {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  }).then(handleResponse);
}